import { useEffect } from 'react';
import { getSocket } from '../Utilities/socketClient';

export default function useChatSocketEvents({
    userId,
    onNewChat,
}) {
    useEffect(() => {
        if (!userId) {
            console.warn('⚠️ [useChatSocketEvents] No userId provided. Hook inactive.');
            return;
        }

        const socket = getSocket();

        if (!socket) {
            console.error('❌ [useChatSocketEvents] Socket instance not found.');
            return;
        }

        // ✅ Define the handler function first so it's not "undefined"
        const handleNewChat = (data) => {
            console.log('📬 [Socket Event] "newChat" received! Triggering refresh...', data);
            if (onNewChat) onNewChat(data);
        };

        // 🔍 LOG: Listener Setup
        console.log(`👂 [useChatSocketEvents] Listening for chat events on user room: ${userId}`);

        // ✅ Attach the listeners using the defined function
        socket.on('newChatCreated', handleNewChat);
        socket.on('newChat', handleNewChat);

        return () => {
            console.log('🔇 [useChatSocketEvents] Cleaning up socket listeners.');
            socket.off('newChatCreated', handleNewChat);
            socket.off('newChat', handleNewChat);
        };
    }, [userId, onNewChat]);
}